import { useEffect, useState, useCallback } from "react";
import React from 'react';
import Select from "react-select";
import useAlert from "common/useAlert";
import SuiBox from "components/SuiBox";
import { useForm } from 'react-hook-form';
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import BeatLoader from "react-spinners/BeatLoader";
import SuiTypography from "components/SuiTypography";
import PersalProvider from "../../../../providers/PersalProvider";
import ActionRequestButtons from "../../components/ActionRequestButtons";
import requesterErrorMessages from '../../../../static/messages/errorMessages.json';

const customStyles = {
  loadingIndicator: (base) => ({
    ...base,
    color: "#ff6347",
    fontSize: '6px',
    marginRight: '1rem'
  }),
};

export const Delete = React.memo(({ setApiRequestObj }) => {

  const { register, handleSubmit, formState: { errors }, reset, getValues, setValue } = useForm();

  const { alert } = useAlert();
  const { clearErrors } = useForm();
  const [email, setEmail] = useState('');
  const [search, setSearch] = useState('');
  const [surname, setSurname] = useState('');
  const [loading, setLoading] = useState('');
  const [idNumber, setIdNumber] = useState('');
  const [onError, setOnError] = useState(true);
  const [firstName, setFirstName] = useState('');
  const [isResult, setIsResult] = useState(false);
  const [reasonCode, setReasonCode] = useState('');
  const [userExist, setUserExist] = useState(false);
  const [institutionCode, setInstitutionCode] = useState([]);
  const [activeInstitutionCode, setActiveInstitutionCode] = useState();

  const [errorMessages, setErrorMessages] = useState(null);

  const deletionCodes = [
    { value: "01", label: "Resigned" },
    { value: "06", label: "Deceased" },
    { value: "05", label: "Disbarred" },
    { value: "02", label: "Suspended" },
    { value: "04", label: "Dismissed for fraud" },
    { value: "03", label: "Under Investigation for fraud" }
  ];

  const onSubmit = () => {
    setApiRequestObj({
      idNumber: idNumber,
      reasonCode: reasonCode,
      onSuccess: handleSuccess,
      RequestType: "PERSAL DELETE",
      institutionCode: activeInstitutionCode,
    })
  };

  const resetUI = async () => {
    setEmail('');
    setSearch('');
    setSurname('');
    setIdNumber('');
    setFirstName('');
    setLoading(false);
    setOnError(false);
    setIsResult(true);
    setLoading(false);
    setUserExist(true);
    setIsResult(false);
    setValue('email', '');
    setValue('search', '');
    setInstitutionCode('');
    setValue('surname', '');
    setValue('firstName', '');
    setRegistrationNumber('');
    setValue('functionRole', '');
    setActiveInstitutionCode('');
    setValue('institutionCode', []);
    setValue('clientReference', '');
    setValue('registrationNumber', '');
  }

  const handleSuccess = (data) => {

    if (data.status === 200) {
      resetUI();
      reset();
      setValue('search', '');
      alert({
        icon: 'success',
        title: 'Process Completed Successfully',
        text: `${firstName + " " + surname}`,
      });
    }
  };

  const submitQry = async () => {
    if (isResult && !userExist) {
      setUserExist(true);
      setIsResult(false);
    }

    setLoading(true);

    const responseCodes = await PersalProvider.retrieveInstitutionCodes();
    const rawCodes = responseCodes?.data?.data || [];
    const formattedCodes = rawCodes.map(code => ({ value: code, label: code }));
    setInstitutionCode(formattedCodes);

    const response = await PersalProvider.retrieveUser(search);

    if (response && response?.data.status === 200 && Object.keys(response.data.data).length > 0) {

      const intermediaryRes = await PersalProvider.retrievePerIntermediaryId(response.data.data.UserId);

      if (intermediaryRes && intermediaryRes?.data.status === 200 && Object.keys(intermediaryRes.data.data).length > 0) {

        setLoading(false);
        setOnError(false);
        setIsResult(true);
        setUserExist(false);

        setEmail(intermediaryRes?.data?.data?.[0]?.data?.[0]?.email ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.email);
        setActiveInstitutionCode(intermediaryRes.data.data[0].institutionCode ?? intermediaryRes.data.data[1].institutionCode);
        setSurname(intermediaryRes?.data?.data?.[0]?.data?.[0]?.surname ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.surname);
        setIdNumber(intermediaryRes?.data?.data?.[0]?.data?.[0]?.idNumber ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.idNumber);
        setFirstName(intermediaryRes?.data?.data?.[0]?.data?.[0]?.firstName ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.firstName);
        
        setValue('email', intermediaryRes?.data?.data?.[0]?.data?.[0]?.email ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.email, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue('surname', intermediaryRes?.data?.data?.[0]?.data?.[0]?.surname ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.surname, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue('idNumber', intermediaryRes?.data?.data?.[0]?.data?.[0]?.idNumber ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.idNumber, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue('firstName', intermediaryRes?.data?.data?.[0]?.data?.[0]?.firstName ?? intermediaryRes?.data?.data?.[1]?.data?.[0]?.firstName, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue('institutionCode', intermediaryRes?.data?.data?.[0]?.institutionCode ?? intermediaryRes?.data?.data?.[1]?.institutionCode ?? [], { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      }

      else if (intermediaryRes && intermediaryRes?.data.status === 200 && Object.keys(intermediaryRes.data.data).length === 0) {
        setLoading(false);
        setOnError(true);
        setUserExist(false);
        alert({
          icon: 'error',
          title: 'User Does Not Exist On Persal',
          text: `${response?.data.data.FirstName + " " + response?.data.data.Surname}`,
        });
      } else {
        setLoading(false);
        setOnError(true);
        setUserExist(false);
        alert({
          icon: 'error',
          title: 'Internal Server Error',
          text: '',
        });
      }
    } else if (response != null && response?.data.status === 200 && Object.keys(response.data.data).length === 0) {
      setLoading(false);
      setOnError(true);
      setUserExist(false);
      alert({
        icon: 'error',
        title: 'User Not Found',
        text: response?.data.message
      });
    } else {
      setLoading(false);
      setOnError(true);
      setUserExist(false);
      alert({
        icon: 'error',
        title: 'Internal Server Error',
        text: '',
      });
    }
  }

  const handleFormSubmit = handleSubmit(onSubmit);

  useEffect(() => {
    setErrorMessages(requesterErrorMessages['teamManagement'].requests['managePersalAgent'].deletePersalAgent);
  }, [])

  return (
    <>
      <SuiBox mt={4} mb={2} lineHeight={1}>
        <SuiTypography variant="h6">Search</SuiTypography>
        <SuiBox display="flex">
          <SuiInput
            id="search"
            name="search"
            disabled={loading}
            onChange={(e) => {
              setSearch(e.target.value);
              setValue('search', e.target.value);
            }}
            placeholder={`Please enter employee number or email`}
          />
          <SuiButton variant="gradient" color="info" sx={{ ml: 1 }}
            onClick={submitQry}>
            Search
          </SuiButton>
        </SuiBox>
      </SuiBox>

      {loading && <SuiBox><BeatLoader color={'#D0021B'} size={10} /> <SuiTypography variant="caption">Validation in progress...</SuiTypography></SuiBox>}

      {errorMessages && !userExist && !onError && search && <>
        <SuiBox mt={6} mb={2} lineHeight={1}>
          <SuiTypography variant="h6">First Name</SuiTypography>
          <SuiBox mt={1} position="relative">
            <SuiInput
              id="firstName"
              disabled={true}
              name="firstName"
              label="firstName"
              value={firstName}
              placeholder="Please enter first name"
              {...register('firstName', { required: errorMessages['firstName']['required'] })}
              onChange={(e) => {
                register('firstName').onChange(e);
                setFirstName(e.target.value);
              }}
            />
          </SuiBox>
          {errors && errors['firstName'] && <p className="error msg pad">{errorMessages['firstName']['required']}</p>}
        </SuiBox>

        <SuiBox mt={6} mb={2} lineHeight={1}>
          <SuiTypography variant="h6">Surname</SuiTypography>
          <SuiBox mt={1} position="relative">
            <SuiInput
              disabled={true}
              id={`surname`}
              value={surname}
              name={`surname`}
              label={`surname`}
              placeholder={`Please enter surname`}
              {...register('surname', { required: errorMessages['surname']['required'] })}
              onChange={(e) => {
                register('surname').onChange(e);
                setSurname(e.target.value);
              }}
            />
          </SuiBox>
          {errors && errors['surname'] && <p className="error msg pad">{errorMessages['surname']['required']}</p>}
        </SuiBox>

        <SuiBox mt={6} mb={2} lineHeight={1}>
          <SuiTypography variant="h6">ID Number</SuiTypography>
          <SuiBox mt={1} position="relative">
            <SuiInput
              disabled={true}
              id={`idNumber`}
              value={idNumber}
              name={`idNumber`}
              label={`idNumber`}
              placeholder={`Please enter id number`}
              {...register('idNumber', { required: errorMessages['idNumber']['required'] })}
              onChange={(e) => {
                register('idNumber').onChange(e);
                setIdNumber(e.target.value);
              }}
            />
          </SuiBox>
          {errors['idNumber'] && <p className="error msg pad">{errorMessages['idNumber']['required']}</p>}
        </SuiBox>

        <SuiBox mt={6} mb={2} lineHeight={1}>
          <SuiTypography variant="h6">Email</SuiTypography>
          <SuiBox mt={1} position="relative">
            <SuiInput
              id={`email`}
              value={email}
              name={`email`}
              label={`email`}
              disabled={true}
              placeholder={`Please enter email`}
              {...register('email', { required: errorMessages['email']['required'] })}
              onChange={(e) => {
                register('email').onChange(e);
                setEmail(e.target.value);
              }}
            />
          </SuiBox>
          {errors && errors['email'] && <p className="error msg pad">{errorMessages['email']['required']}</p>}
        </SuiBox>

        <SuiBox mt={4} mb={2} lineHeight={1}>
          <SuiTypography variant="h6">Institution Code</SuiTypography>
          <SuiBox position="relative">
            <Select
              isSearchable={false}
              id="institutionCode"
              key="institutionCode"
              options={institutionCode}
              classNamePrefix="custom-select"
              value={institutionCode.find(option => option.value === activeInstitutionCode) || null}
              placeholder="Please select institution code"
              className="select-control select-one select-with-html"
              register={register('institutionCode', errorMessages['institutionCode'])}
              onChange={(selectedOption) => {
                const selectedValue = selectedOption ? selectedOption.value : '';
                setActiveInstitutionCode(selectedValue);
                setValue('institutionCode', selectedValue);
              }}
            />
          </SuiBox>
          {errors['institutionCode'] && <p className="error msg pad">{errorMessages['institutionCode']['required']}</p>}
        </SuiBox>

        <SuiBox mt={4} mb={2} lineHeight={1}>
          <SuiTypography variant="h6">Reason for deletion</SuiTypography>
          <SuiBox position="relative">
            <Select
              id={`reasonCode`}
              key={`reasonCode`}
              isSearchable={false}
              options={deletionCodes}
              classNamePrefix="custom-select"
              placeholder={`Please select deletion reason`}
              className="select-control select-one select-with-html"
              register={register('reasonCode', errorMessages['reasonCode'])}
              onChange={(e) => { setReasonCode(e.value); setValue('reasonCode', e.value); }}
            />
          </SuiBox>
          {errors['reasonCode'] && <p className="error msg pad">{errorMessages['reasonCode']['required']}</p>}
        </SuiBox>

        <ActionRequestButtons onSubmit={handleFormSubmit} isDisabled={userExist} />
      </>}</>)
});
